
import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import CreateRole from "@/components/Auth/CreateRole.vue";
import { authMixin } from "../../auth/mixins";
import loader from "@/components/loader/nipigeloader.vue";
@Component({
  components: {
    CreateRole,
    loader,
  },
})
export default class Role extends Mixins(authMixin) {
  @Prop(Object) auth: any;
  private header: string = "Create a Role";
  private roles: any[] = [];
  private role: any = {};
  private roleModal: boolean = false;
  private roleColumns: any[] = [
    {
      key: "name",
      sortable: true,
    },
    {
      key: "description",
    },
    {
      key: "action",
    },
  ];
  loading = true;
  perPage = 10;
  hover = true;
  striped = false;
  filter = "";
  bordered = true;
  small = false;
  fixed = false;
  dark = false;
  currentPage = 1;

  private permissionMap: any = {};
  private allPermissions: any[] = [];

  private insertRole(payload) {
    this.$store
      .dispatch("role/createRole", payload)
      .then((result) => {
        this.roles.push(result.response);
        this.$toasted.success("Successfully new role created");
      })
      .catch((error) => this.$toasted.error(error.message));
  }

  private async handleEdit() {
    const { _id, name, description } = this.role;
    const payload = {
      _id,
      data: {
        name,
        description,
      },
    };
    this.$store
      .dispatch("role/updateRole", payload)
      .then((result) => {
        this.$swal({
          title: "Success",
          text: "Role edited successfully!!",
          type: "success",
        });
        this.clearModal();
      })
      .catch((e) => this.clearModal());
  }

  private async deleteRole({ item }) {
    await this.$swal({
      title: "Are you sure?",
      text: "You can't revert this action!!",
      type: "info",
    }).then((result) => {
      if (result.value) {
        this.$store.dispatch("role/deleteRole", item._id).then((res: any) => {
          this.roles.filter((e, i) =>
            item._id === e._id ? this.roles.splice(i, 1) : null
          );
          this.$toasted.success("Deleted!");
        });
      }
    });
  }

  private clearModal() {
    this.role = {};
    this.roleModal = false;
  }

  private editRole(row) {
    this.role = row.item;
    this.header = "Edit a Role";
    this.roleModal = true;
  }

  private async expandRole(row) {
    console.log("id : ", row.item._id);
    this.$router.push({
      name: "RolePermission",
      query: {
        role: row.item._id,
      },
    });
    // let opening = !row.detailsShowing;
    // row.toggleDetails();
    // if(!opening){ return; }
    // const { item } = row;
    // const { permissions } = await getPermissionsByRole(item._id);
    // this.permissionMap[item._id] = permissions || [];
  }

  private async addPermissionToRole(selectedOption, id, row) {
    console.log("got arguments : ", selectedOption, " id : ", id);
    const role = row.item._id;
    console.log("role : ", role);
    Object.assign(this.permissionMap, {
      [role]: this.permissionMap[role].concat([selectedOption]),
    });
  }

  public async mounted() {
    this.loading = true;
    await this.$store
      .dispatch("role/fetchRoles")
      .catch((error) => console.log(error));
    await this.$store
      .dispatch("permission/fetchAllPermission")
      .catch((error) => console.log(error));
    this.roles = this.$store.getters["role/GetRoleList"];
    this.allPermissions =
      this.$store.getters["permission/GetAllPermissionList"];
    this.loading = false;
  }
}
